











import { Component, Vue } from 'vue-property-decorator'
import VBackButton from '@/components/VBackButton.vue'

@Component({ components: { VBackButton } })
export default class NotFound extends Vue {
}

